/**
 * Color Swatches for Product Cards
 * Handles clicking color swatches to change product card images
 */

(function() {
    'use strict';
    
    // Prevent multiple initializations
    if (window.colorSwatchesInitialized) {
      return;
    }
    window.colorSwatchesInitialized = true;
  
    class ColorSwatchesHandler {
      constructor() {
        this.init();
      }
  
      init() {
        // Initialize on page load
        this.initializeSwatches();
        
        // Re-initialize when new content is loaded (e.g., via AJAX)
        document.addEventListener('shopify:section:load', () => this.initializeSwatches());
      }
  
  initializeSwatches() {
    const swatchContainers = document.querySelectorAll('.card-color-swatches');
    
    swatchContainers.forEach(container => {
      // Skip if already initialized
      if (container.dataset.initialized === 'true') return;
      
      container.dataset.initialized = 'true';
      
      const swatchButtons = container.querySelectorAll('.card-swatch-button');
      const productCard = container.closest('.card-wrapper');
      const productImage = productCard?.querySelector('.card__media .media img:first-of-type');
      const productTitleElement = productCard?.querySelector('.card-product-title-text');
      const productTitleLink = productCard?.querySelector('.card-product-title');
      const sizeOverlay = productCard?.querySelector('[data-size-overlay]');
      
      if (!productImage) return;
      
      // Get the base product title (without color variant)
      const baseTitle = productTitleLink?.dataset.productTitle || '';
      
      // Size overlay is now static - no need to update based on color
      
      // Don't prevent container clicks, only button clicks
      swatchButtons.forEach(button => {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.handleSwatchClick(button, swatchButtons, productImage, productTitleElement, baseTitle, sizeOverlay);
        });
      });
    });
  }
  
  handleSwatchClick(clickedButton, allButtons, productImage, productTitleElement, baseTitle, sizeOverlay) {
    // Prevent clicking on already active swatch
    if (clickedButton.classList.contains('active')) return;
    
    // Remove active state from all swatches
    allButtons.forEach(btn => btn.classList.remove('active'));
    
    // Add active state to clicked swatch
    clickedButton.classList.add('active');
    
    // Get the variant data
    const variantImage = clickedButton.dataset.variantImage;
    const variantImageSrcset = clickedButton.dataset.variantImageSrcset;
    const variantImageAlt = clickedButton.dataset.variantImageAlt;
    const colorName = clickedButton.dataset.colorName;
    
    // Update the product title with the selected color
    if (productTitleElement && colorName) {
      const newTitle = this.updateTitleWithColor(baseTitle, colorName);
      productTitleElement.textContent = newTitle;
    }
    
    // Size overlay is now static - no need to update based on color
    
    // Update the product card image with fade effect
    if (variantImage && productImage) {
      productImage.classList.add('changing');
      
      // Small delay for smooth transition
      setTimeout(() => {
        productImage.src = variantImage;
        
        if (variantImageSrcset) {
          productImage.srcset = variantImageSrcset;
        }
        
        if (variantImageAlt) {
          productImage.alt = variantImageAlt;
        }
        
        // Remove changing class after image loads
        productImage.addEventListener('load', () => {
          productImage.classList.remove('changing');
        }, { once: true });
      }, 0);
    }
  }
  
  updateSizeOverlay(sizeOverlay, swatchButton) {
    const sizeAvailabilityData = swatchButton.dataset.sizeAvailability;
    
    if (!sizeAvailabilityData) return;
    
    try {
      const sizeAvailability = JSON.parse(sizeAvailabilityData);
      const sizeItems = sizeOverlay.querySelectorAll('.size-item');
      
      sizeItems.forEach(sizeItem => {
        const sizeValue = sizeItem.dataset.sizeValue;
        const isAvailable = sizeAvailability[sizeValue];
        
        // Remove existing classes
        sizeItem.classList.remove('size-available', 'size-soldout');
        
        // Add appropriate class based on availability
        if (isAvailable === true) {
          sizeItem.classList.add('size-available');
        } else {
          sizeItem.classList.add('size-soldout');
        }
      });
    } catch (e) {
      console.error('Error parsing size availability data:', e);
    }
  }
  
  updateTitleWithColor(baseTitle, colorName) {
    // If title contains " - ", replace the part after it with the new color
    if (baseTitle.includes(' - ')) {
      const parts = baseTitle.split(' - ');
      return `${parts[0]} - ${colorName}`;
    }
    // If title contains " / ", replace the part after it with the new color
    else if (baseTitle.includes(' / ')) {
      const parts = baseTitle.split(' / ');
      return `${parts[0]} / ${colorName}`;
    }
    // Otherwise, just append the color
    else {
      return `${baseTitle} - ${colorName}`;
    }
  }
    }
  
    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => new ColorSwatchesHandler());
    } else {
      new ColorSwatchesHandler();
    }
  })();
  
  